// React
import React from 'react';
import PropTypes from 'prop-types';

// Cybs
import MenuButton from '@cybs-ui/components/lib/menu-button';

const IconMenu = props => {
  const { dataTest, disabled, buttonProps: buttonPropsProp, i18n } = props;
  const buttonProps = {
    ...IconMenu.defaultProps.buttonProps,
    ...buttonPropsProp
  };

  return (
    <MenuButton
      {...props}
      buttonProps={{
        ...buttonProps,
        dataTest,
        disabled,
        i18n: {
          ...i18n,
          ...buttonProps?.i18n
        },
        variant: 'icon'
      }}
      dataTest={`${dataTest}-cybsIconMenu`}
    />
  );
};

IconMenu.propTypes = {
  /**
   * Props to applied to the input element.
   */
  buttonProps: PropTypes.shape({
    /**
     * Color scheme of button
     */
    colorScheme: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),

    /**
     * Name for the button icon.
     */
    iconClass: PropTypes.string,

    i18n: PropTypes.shape({
      /**
       * Input error text.
       */
      tooltipLabel: PropTypes.string
    }),

    /**
     * Icon type
     */
    iconType: PropTypes.oneOf([
      'dark',
      'dark-outline',
      'dark-tiny',
      'light',
      'light-fill',
      'light-outline',
      'light-tiny'
    ]),

    /**
     *Callback fired when the button element is clicked.
     */
    onButtonClick: PropTypes.func,

    /**
     * Resolution for the button icon.
     */
    resolution: PropTypes.oneOf(['high', 'low', 'tiny'])
  }),

  /**
   * dataTest string for testing.
   */
  dataTest: PropTypes.string.isRequired,

  /**
   *If `true`, the combobox  is not interactive.
   */
  disabled: PropTypes.bool,

  /**
   * Localization
   */
  i18n: PropTypes.shape({
    /**
     * Input error text.
     */
    tooltipLabel: PropTypes.string
  })
};

IconMenu.defaultProps = {
  buttonProps: {
    colorScheme: 'primary',
    iconClass: 'options',
    iconType: 'light',
    onButtonClick: () => {},
    resolution: 'low'
  },
  disabled: false,
  i18n: {
    // tooltipLabel is preferred field. This is least obstructive default prop.
    label: 'More options'
  }
};

IconMenu.displayName = 'IconMenu';

export default IconMenu;
